/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapMutations } from 'vuex';
import purchaseService from './../../../../services/purchase';
import previewMessage from './../../../../components/previewMessage/previewMessage.vue';
import store from './../../../../store';

export default {
  data() {
    return {
      loading: true,
      tabIndex: 'first',
      currentPurchase:{
        products:[],
        warehouse:{
          name:'',
        },
        supplier: {

        },
        purchaseStatus:{
          name:'',
        },
        stock:{
          name:'',
        }
      },
      hashId: '',
      dropdownState: false,
      userLang: 'no',
    };
  },

  computed: {

    productList() {
      return this.currentPurchase.products.map(c => ({
        sku: c.product.sku,
        name: c.product.name,
        qty: c.qty,
        qtyReceive: c.qtyReceive,
        qtyDamage: c.qtyDamage,
        notes: c.notes,
      }));
    },

  },

  watch: {
    currentPurchase(currentPurchase) {
      console.log(currentPurchase);
    },
  },

  created() {
     this.loading = false;
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalSize: 'SET_MODAL_SIZE',
      setModalProps: 'SET_MODAL_PROPS',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING',
    }),

    previewSendDocument() {
      let tempContact = [];
      if (typeof this.currentPurchase.warehouse.contact.email !== 'undefined' && this.currentPurchase.warehouse.contact.email!== '') {
        tempContact.push({
          id: 0,
          email: this.currentPurchase.warehouse.contact.email,
          first_name: this.currentPurchase.warehouse.contact.firstName,
          last_name: this.currentPurchase.warehouse.contact.lastName,
          contact_types: [{name: 'Primary'}]
        });
      }

      if (typeof this.currentPurchase.supplier.contact.email !== 'undefined' && this.currentPurchase.supplier.contact.email !== '') {
        tempContact.push({
          id: 1,
          email: this.currentPurchase.supplier.contact.email,
          first_name: this.currentPurchase.supplier.name,
          last_name: '',
          contact_types: [{name: 'Primary'}]
        });
      }

      console.log(tempContact);

      purchaseService.showPurchaseEmailInformation(this.$route.params.id)
        .then((purchaseEmailInformation) => {
          console.log(purchaseEmailInformation);
          this.setModalContent(() => previewMessage);
          this.setModalSize('full');
          this.setModalProps({
            isEmailInput: true,
            isMultiSelected: true,
            contacts: (tempContact.length > 0) ? tempContact : null,
            message: purchaseEmailInformation.message,
            subject: purchaseEmailInformation.title,
            userEmail: purchaseEmailInformation.userEmail,
            notes: "",
            cc: true,
            headerTexts: [
              `${this.$t('static.bills.edit.from')}: ${purchaseEmailInformation.fromName} <${purchaseEmailInformation.fromEmail}>`,
            ],
            attachments: [{
              attachmentName: purchaseEmailInformation.attachmentName,
              action: this.showPurchase,
            }],
            buttons: [{
              name: this.$t('button.cancel'),
              action: this.cancelModal,
              title: this.$t('button.cancel'),
            },
            {
              name: (this.isPending ? this.$t('button.send') : this.$t('button.resend')),
              action: this.sendPurchase,
              title: (this.isPending ? this.$t('button.send') : this.$t('button.resend')),
            },
          ],
          });
          this.toggleModal(true);
        })
        .catch(() => {
          // Could not predict how this email will be sent.
          // Show some handling
        });
    },

    /**
     * Send the invoice to the client email.
     */
    sendPurchase(ev, test = false) {
      this.sendLoading = true;
      this.setModalButtonLoading(true);
        purchaseService.send(
          store.state.route.params.id, {
          email_to: store.state.modal.modalProps.email_to,
          message: store.state.modal.modalProps.message,
          subject: store.state.modal.modalProps.subject,
          cc: store.state.modal.modalProps.cc,
          notes: store.state.modal.modalProps.notes,
          test: test
        })
        .then(() => {
          this.toggleModal(false);
          this.sendLoading = false;
          this.setModalButtonLoading(false);
          purchaseService.show(store.state.route.params.id);
          this.$message({
            showClose: true,
            message: this.$t('static.purchase.edit.sendPurchaseSuccess'),
            type: 'success',
          });
        }).catch(() => {
          this.toggleModal(false);
          this.sendLoading = false;
          this.setModalButtonLoading(false);
          this.$message({
            showClose: true,
            message: this.$t('static.purchase.edit.sendPurchaseError'),
            type: 'error',
          });
        });
    },

    sendTestPurchase(ev) {
      this.sendPurchase(ev, true);
    },

    showPurchase() {
      purchaseService.showPdf(this.hashId, this.userLang);
    },

    downloadPurchase() {
      purchaseService.download(this.hashId, this.userLang);
    },

    toggleDropdown() {
      this.dropdownState = !this.dropdownState;
    },

    /**
     * Cancel modal trigger
     */
    cancelModal() {
      this.toggleModal(false);
    },

    /**
     * Check if it is still pending.
     */
    isPending() {
      return this.currentPurchase.purchaseStatus === 'Pending';
    },

    markAsDone() {
      this.loading = false;


      purchaseService.markAsDone(this.$route.params.id, [])
      .then(() => {
        this.$message({
          message: this.$t('static.purchase.update.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'inventory.purchase.index',
        });
      }).catch((errors) => {

      });
    },
    markAsDraft() {
      this.loading = false;

      purchaseService.saveAsDraft(this.$route.params.id, [])
      .then(() => {
        this.$message({
          message: this.$t('static.purchase.update.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'inventory.purchase.index',
        });
      }).catch((errors) => {

      });
    },
  },
  mounted() {
    Promise.all([
      purchaseService.show(this.$route.params.id),
    ]).then((data) => {
      this.currentPurchase = data[0];
      this.hashId = this.currentPurchase.hashId;
      this.userLang = this.currentPurchase.userLang;
    });
  },
  components: {
    VTable: require('./../../../../components/table/table.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/purchase/view/view.js